import React, { useState, useEffect } from "react";
import { sendData, getData } from "../../../services/auth";
import { uriList } from "../../../helpers/config";
import { Button } from "reactstrap";
import { width, generateId } from "../../../helpers";


import { confirmSwal, swalError } from "../../../helpers/swal";
import * as moment from "moment";
import { Aguarde } from '../../../helpers/general'
import { useSelector } from "react-redux";
import InclusaoRequisitos from "./InclusaoRequisitos";
import { Pagination, InputLabelAlert, DropDownMenu } from '../../../common/layout'


const Requisitos = (props) => {
    const [allRequisitos, setAllRequisitos] = useState(null);
    const [requisitos, setRequisitos] = useState(null);
    const [modal, setModal] = useState(false);
    const [data, setData] = useState({ id: 0, descricao: "", file: null });
    const _login = useSelector((state) => state.login);
    const [excluindo, setExcluindo] = useState(false)
    const [carregando, setCarregando] = useState(true)
    const [actualPage, setActualPage] = useState(0)
    const [pesquisa, setPesquisa] = useState("")
    const [tiposDocumento, setTiposDocumento] = useState(null)
    const [clientes, setClientes] = useState([])
    const [loading, setLoading] = useState(true)

    async function _getData() {
        setCarregando(true)
        setLoading(true)

        setRequisitos(null)
        setAllRequisitos(null)
        await sendData({ uri: uriList("requisitos"), content: { empresaid: _login.empresaid } })
            .then((res) => {
                console.log("Requisitos: ", res);

                // if (res.status && parseInt(res.status) > 200) throw new Error();
                if (res?.data) {
                    console.log("Requisitos(1): ", res);
                    setRequisitos(res.data || [])
                    setAllRequisitos(res.data || [])
                }
            })
            .catch((e) => {
                console.log(e);
                alert("Erro ao obter Requisitos.\n" + e.message);
            });

        setCarregando(false)

        setTiposDocumento(null)
        await getData({ uri: uriList("tiposDocumento") })
            .then((res) => {
                if (res.status && parseInt(res.status) > 200) throw new Error();
                setTiposDocumento(res)
                // console.log("Documentos.index._getData(Tipos de Documento): ", res);
                if (res && res.length)
                    setData({ ...data, tipo_documentoid: res[0].ID })
            })
            .catch((e) => {
                console.log(e);
                alert("Erro ao obter Tipos de Documento.\n" + e.message);
            });

        setClientes(null)
        await sendData({ uri: uriList("buscarClientes") })
            .then((res) => {
                if (res.status && parseInt(res.status) > 200) throw new Error();
                setClientes(res.data)
                // console.log("Documentos.index._getData(Tipos de Documento): ", res);
            })
            .catch((e) => {
                console.log(e);
                alert("Erro ao obter Tipos de Documento.\n" + e.message);
            });

        setLoading(false)
    }

    useEffect(() => {
        _getData();
    }, []);



    async function closeModal(gravou) {
        setModal(false)
        if (gravou)
            await _getData();
    }

    async function handleDelete(element) {
        function callback(p) {
            console.log("Requisitos.handleDelete: ", element)
            if (p) {
                setExcluindo(true)
                sendData({ uri: uriList("requisitosDel"), content: { ...element, } })
                    .then((res) => {
                        console.log("Requisitos - Deletado: ", res);
                        setExcluindo(false)
                        if (res.status && parseInt(res.status) > 200) {
                            swalError({
                                title: `Erro ao excluir registro! \n${res.data || res.message || res.erro}`,
                            });
                            return
                        }

                        _getData();
                    })
                    .catch(error => {
                        console.log(error);
                        setExcluindo(false)
                        swalError({
                            title: `Erro ao excluir registro! \n${error.message}`,
                        });
                    })
            }
        }

        confirmSwal({ callback, title: "Confirma a execução do processo?" });
    }

    function handlePage(e) {
        setActualPage(e.currentTarget.value);
    }

    function handleEdit(e) {
        setData(e)
        setModal(true);
    }

    function handlePesquisa(e) {
        let _value = e.target.value.toLowerCase()
        setPesquisa(e.target.value)
        if (_value && allRequisitos) {
            console.log("Requisitos.handlePesquisa:", _value)
            let _docs = allRequisitos.filter(e =>
                e.PESSOA?.toLowerCase().indexOf(_value) >= 0 || e.CLIENTE?.toLowerCase().indexOf(_value) >= 0 ||
                e.STATUS?.toLowerCase().indexOf(_value) >= 0
            )

            console.log("Requisitos.handlePesquisa(docs):", _docs)
            setRequisitos(_docs)
        }
        else
            setRequisitos(allRequisitos)

        setActualPage(0);
    }

    return (
        <>
            {modal && <InclusaoRequisitos
                onCloseEv={closeModal}
                empresa={_login.empresaid}
                usuario={_login.usuarioid}
                clientes={clientes}
                tipos={tiposDocumento}
                data={data}
            />}
            <div
                style={{
                    flexDirection: width() == "mobile" ? "column" : "",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                }}
            >
                <div className="col-md-12 mb-5">
                    <div className={`${width() == "mobile" ? "h3" : "h1"} center-elements`}>Requisitos de Integração</div>
                </div>
                <div className="col-md-12 mb-1 d-flex justify-content-between">
                    <div className="col-3 d-flex align-items-center justify-content-left p-0">
                        <button className="btn btn-secondary"
                            onClick={e => {
                                if (props.onCloseEv)
                                    props?.onCloseEv()
                            }}

                        >
                            <i className="fa fa-window-close"></i>
                        </button>
                        <button className="btn btn-primary ml-1" onClick={() => {
                            setData(null)
                            setModal(true);
                        }} disabled={carregando || loading}>
                            <i className="fa fa-plus-circle"></i>
                        </button>
                    </div>
                    <div className="col-5 p-0">
                        <InputLabelAlert
                            type="text"
                            label="Pesquisa"
                            id="pesquisa"
                            cifrao={false}
                            value={pesquisa}
                            handle={handlePesquisa}
                            focus={true}
                        />
                    </div>
                </div>

                <div className="col-md-12" style={{ overflowX: "auto" }}>
                    <Pagination
                        detailed={requisitos}
                        actual={actualPage}
                        changePage={handlePage}
                    />
                    <table className="table table-striped table-hover mb-1 rounded" >
                        <thead className="thead-dark">
                            <tr>
                                <th scope="col" style={{ width: "5%" }}>#</th>
                                <th scope="col" style={{ width: "60%" }}>Cliente</th>
                                <th scope="col" style={{ width: "30%" }}>Tipo de Documento</th>
                                <th scope="col" style={{ width: "5%" }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {requisitos && requisitos?.map((doc, index) =>
                                index >= actualPage * 10 &&
                                index < (actualPage + 1) * 10 &&
                                (
                                    <tr style={{ cursor: "pointer" }} onDoubleClick={() => handleEdit(doc)} >
                                        <th scope="row" style={{ width: "5%" }}>{index + 1}</th>
                                        <td style={{ width: "60%" }}>{doc.CLIENTE}</td>
                                        <td style={{ width: "30%" }}>{doc.TIPO_DOCUMENTO}</td>
                                        <td style={{ width: "5%" }}>
                                            <div className="d-flex justify-content-center " style={{ overflow: 'hidden', }}>
                                                <DropDownMenu items={[
                                                    { descricao: "Editar", onClick: e => handleEdit(doc), className: "fa fa-edit", title: "Editar o Requisito" },
                                                    { descricao: "Excluir", onClick: e => handleDelete(doc), className: "fa fa-trash", title: "Excluir o Requisito", color: "red" },
                                                ]} />
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="12" className="text-left">
                                    Total de Registros: {requisitos && requisitos.length}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* </div> */}
                    {/* <Pagination
                        detailed={requisitos}
                        actual={actualPage}
                        changePage={handlePage}
                    /> */}
                </div>
            </div>

            {excluindo && <Aguarde />}
            {carregando && <Aguarde legenda="Aguarde, carregando registros..." />}
        </>
    );
}

export default Requisitos;

